export default "__VITE_ASSET__BbC07wVJ__"